import "./App.scss";
import Home from "./Screens/Home";
import About from "./Screens/About";
import Program from "./Screens/Program";
import Achievements from "./Screens/Achievements";
import Placement from "./Screens/Placement";
import Students from "./Screens/Students";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Feedback from "./Screens/feedBack/form";
import StoryblokClient from "storyblok-js-client";
import React, { useState, useEffect } from "react";
import BlogSection from "./Screens/Students/blogSection"
import BlogDetails from "./Screens/BlogDetails/BlogDetails";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { HelmetProvider } from "react-helmet-async";
import Product from "./Screens/ProductPage/Product";
import FeedbackFormData from "./Screens/feedBack/FeedbackFormData";
import LinkedinImg from './Assets/linkedin-removebg-preview.png';
import Instaimg from "./Assets/instagram.png"
import LinkedInModal from "./Components/FeedbackModal";

// First Storyblok Client
const Storyblok = new StoryblokClient({
  accessToken: "l2PrYYzvkNva2BrrOAK3tQtt",
});

// Second Storyblok Client (Public Token)
const Storyblok2 = new StoryblokClient({
  accessToken: "A563QXkg20rtACOrfdm2vQtt",
});

function App() {
  const [portFolioPage, setPortFolioPage] = useState(null);
  const [secondStoryblokContent, setSecondStoryblokContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // First Storyblok fetch
    Storyblok.get("cdn/stories/bt_portfolio", {
      version: "published",
    })
      .then((response1) => {
        setPortFolioPage(response1.data.story.content);
        console.log("Storyblok1 success:", response1.data);
      })
      .catch((error) => {
        console.error("Storyblok1 Error:", error);
      });

    // Second Storyblok fetch
    Storyblok2.get("cdn/stories/bt_portfolio", {
      version: "published",
    })
      .then((response2) => {
        setSecondStoryblokContent(response2.data.story.content);
        console.log("Storyblok2 Content:", response2.data.story.content);
        console.log("Storyblok2 FeedbackForm:", response2.data.story.content.feedbackForm);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Storyblok2 Error:", error);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return null;
  }

  // console.log("Li ked in card: ", portFolioPage?.body[8]);
  console.log("Second Storyblok Content: ", secondStoryblokContent);
  

  return (
    <div>
      <Router>
        <div className="App">
          <div className="icons">
            <a href="https://instagram.com/the_better_tomorrow_?igshid=NzZlODBkYWE4Ng==">
              <img src={Instaimg} alt="Instagram" />
            </a>
            <a href="https://www.linkedin.com/company/better-tomorrow-training-institute/">
              <img src={LinkedinImg} alt="LinkedIn" />
            </a>
          </div>
            <HelmetProvider>
          <Routes>
            {/* <Route path="/" element={<Home data={portFolioPage?.body[0]} />} /> */}
            <Route path="/" element={<Home data={{ feedbackForm: secondStoryblokContent?.feedbackForm?.[0], cards:  portFolioPage?.body[8]}} />} />
            <Route path="/About" element={<About data={secondStoryblokContent?.feedbackForm?.[6]} />} />
            <Route path="/Program" element={<Program data={portFolioPage?.body[2]} />} />
            <Route path="/Achievements" element={<Achievements data={secondStoryblokContent?.feedbackForm?.[3]} />} />
            <Route path="/Placement" element={<Placement data={secondStoryblokContent?.feedbackForm?.[5]} />} />
            <Route path="/Feedback" element={<Feedback data={portFolioPage?.body[5]} />} />
            <Route path="/Students" element={<Students data={{ feedbackForm: secondStoryblokContent?.feedbackForm?.[7] }} />} />
            <Route path="/Blog" element={<BlogSection blogs={portFolioPage?.body[7]?.blogs} />} />
            <Route path="/blogs/:slug" element={<BlogDetails blogs={portFolioPage?.body[7]?.blogs} />} />
            {/* <Route path="/Product" element={<ScrollProduct/>} /> */}
            <Route path="/product" element={<Product/>} />
            <Route path="/LRP" element={<FeedbackFormData cmsData={secondStoryblokContent?.feedbackForm?.[1]} />} />
          </Routes>
            </HelmetProvider> 
        </div>
      </Router>
      <LinkedInModal />
      <ToastContainer autoClose={5000} />
    </div>
  );
}

export default App;

